<mat-form-field #triggerElement class="selectDropDown custom-scrollbar csf" [appearance]="appearance"
                subscriptSizing="dynamic"
                [matMenuTriggerFor]="menu"
                (menuOpened)="onMenuOpen2()"
                [ngClass]="dynamicClasses">
    <mat-label>{{ selectedEntityName ? (label || 'Entity') : (placeHolder || 'Select Entity') }}</mat-label>
    <input matInput readonly [value]="selectedEntityName" [disabled]="!allowedToChangeEntity" class="clickable-el">
    <mat-icon *ngIf="allowedToChangeEntity" matSuffix [svgIcon]="'chevron-down-accent'"></mat-icon>
</mat-form-field>
<mat-menu #menu="matMenu" class="matTreeSelect" [xPosition]="xPosition">
    <button *ngIf="selectedEntityName && allowedToChangeEntity && isAllowedToReset" mat-menu-item
            (click)="resetEntity($event)">
        <i class="bi bi-x"></i>
        <span>Clear Selection</span>
    </button>
    <div *ngIf="showTreeStructure">
        <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="getChildren" class="example-tree " >
            <mat-tree-node #treeNode *matTreeNodeDef="let node" matTreeNodeToggle class="leaf-node"
                           [attr.data-node-id]="node.id">
                <mat-radio-button
                        [ngClass]="(isApplySelectableFilter && !node?.isSelectable) ? 'disabled-item':''"
                        [attr.data-node-id]="node.id"
                        [disabled]="(isApplySelectableFilter && !node?.isSelectable)"
                        [checked]="isNodeSelected(node)"
                        (change)="handleSelectedEntity(node)"
                        [style.--node-color]="getNodeColor(node)"
                >

                    <li class="mat-tree-node"  [ngClass]="[
      (isApplySelectableFilter && !node?.isSelectable) ? 'disabled-item' : '',
      node?.entityTypeId | cssClassBasedOnEntityTypeId
    ]" >
                        {{ node.entityTypeId === isTeamEntity ? (node.teamCode + ' - ' + node.name) : node.name }}
                    </li>
                </mat-radio-button>
            </mat-tree-node>
            <mat-nested-tree-node  *matTreeNodeDef="let node; when: hasChild" class="node">
                <li>
                    <div class="branch-wrapper" style="position: relative;">
                        <mat-radio-button
                                [disabled]="(isApplySelectableFilter && !node?.isSelectable)"
                                [ngClass]="(isApplySelectableFilter && !node?.isSelectable) ? 'disabled-item':''"
                                [checked]="isNodeSelected(node)"
                                (change)="handleSelectedEntity(node)"
                                class="vertical"
                                [style.--node-color]="getNodeColor(node)"
                        >
                            <div #treeNode class="node-content" [attr.data-node-id]="node.id">
                                    <span [ngClass]="node?.entityTypeId | cssClassBasedOnEntityTypeId">
                                        {{ node.name }}
                                    </span>
                            </div>
                        </mat-radio-button>
                        <ng-container *ngFor="let child of getChildren(node); let i = index">
                            <div
                                    class="dynamic-vertical-line"
                                    [style.height.px]="getLineHeightToChild(node, i)"
                                    [style.border-color]="getNodeColor(node)"
                            >
                            </div>
                        </ng-container>
                        <ul [class.example-tree-invisible]="!tree.isExpanded(node)">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                    </div>
                </li>
            </mat-nested-tree-node>
        </mat-tree>
    </div>
</mat-menu>